module.exports = __webpack_public_path__ + "img/4-loading.2f211e9b.png";